// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"48":"6c662740","119":"31d6cfe0","144":"4960a39c","361":"661da2ee","405":"096fe000","562":"97d19914"}[chunkId] + ".chunk.css";
};